<template>
  <div class="news-modal">
    <!-- Modal -->
    <div
      class="modal fade"
      id="newsModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      ref="modal"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body news-content">
            <div class="news-content-cover">
              <img :src="content.avatar" :alt="content.title" />
            </div>
            <h2 class="news-content-title">{{ content.title }}</h2>
            <p class="news-content-date">发布时间 : {{ content.created }}</p>
            <p class="news-content-desc" v-show="content.summary">
              {{ content.summary }}
            </p>
            <div class="news-content-main" v-html="content.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsModal",
  props: {
    content: {
      type: Object,
      require: true
    },
    show: Boolean
  },
  watch: {
    show(value) {
      if (value) {
        this.toggle();
      }
    }
  },
  mounted() {
    $(this.$refs.modal).on("hidden.bs.modal", () => {
      this.$emit("update:show", false);
    });
  },
  beforeDestroy() {
    $(this.$refs.modal).modal("dispose");
  },
  methods: {
    toggle() {
      $(this.$refs.modal).modal("toggle");
    }
  }
};
</script>

<style lang="scss" scoped>
.news-content {
  img {
    width: 100%;
  }
  &-title {
    text-align: center;
    margin: 2rem 0 1rem;
  }
  &-date {
    font-size: 14px;
    text-align: center;
    color: #bbb;
    margin-bottom: 2rem;
  }
  &-desc {
    padding: 1rem;
    background: #ececec;
    color: #707070;
  }
}
</style>
